import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { NJSidebarContent } from '@engie-group/fluid-design-system-react';
import * as Sentry from '@sentry/react';

import { globalSelector, useFetchSingleFlexSupplierByUserQuery, useFetchSitesQuery, userSelector } from '../../../store';
import { Header } from '../../header';
import { Sidebar, sideBarItems } from '../../sidebar';
import { Spinner } from '../../spinner';
import styles from './DefaultLayout.module.scss';

export const DefaultLayout = () => {
  const isLoading = useSelector(globalSelector).loading;
  const user = useSelector(userSelector);

  useFetchSitesQuery();
  useFetchSingleFlexSupplierByUserQuery({ userId: user.id! });

  useEffect(() => {
    if (user.id && user.email) {
      Sentry.setUser({ id: user.id, username: user.email });
    }
  }, [user]);

  return (
    <div className={styles['default-layout']}>
      <Sidebar items={sideBarItems} />
      <NJSidebarContent isAboveContent className="tw-h-screen">
        {isLoading ? (
          <Spinner />
        ) : (
          <div className="tw-flex tw-flex-col tw-h-full">
            <Header />
            <main className="container-fluid px-2 pb-2 tw-flex-grow" data-testid="default-layout-main">
              <Outlet />
            </main>
          </div>
        )}
      </NJSidebarContent>
    </div>
  );
};
